import styled from '@emotion/styled';

import { disabledColor, primaryColor } from '@zego/theme';

const Legals = styled('div')(`
  counter-reset: section;
  h2,
  h3,
  h4,
  h5,
  h6,
  li,
  p {
    color: ${disabledColor(10)};
    margin-top: 0;
    line-height: 1.2;
    font-size: 14px;
  }

  li {
    margin-bottom: 1.2rem;
  }

  a:link, a:visited {
    color: ${primaryColor(11)};
  }

  ol > li::before,
  h2 {
    font-size: 18px;
    font-weight: bold;
    margin-top: 2.4rem;
    margin-bottom: 1.2rem;
  }

  ol > li::before {
    margin-top: 0;
  }

  ol li ol li::before,
  ol li ol li ol li::before {
    font-weight: normal;
    font-size: 1rem;
    margin-bottom: 1.2rem;
    font-size: 14px;
  }

  h3 {
    text-decoration: underline;
    font-weight: normal;
    font-size: 1rem;
    margin-bottom: 1.2rem;
    font-size: 14px;
  }

  ol {
    list-style-type: none;
    margin: 0 0 0 3.5rem;
    padding: 0;
    line-height: 1.2;
  }

  ol ol {
    margin-left: 0;
  }

  ol ol ol {
    margin-bottom: 0;
  }

  ul {
    list-style-type: none;
    margin: 0 0 0 3.5rem;
    padding: 0;
    line-height: 1.2;
  }

  li li li ol,
  li li li ul {
    margin-left: 2rem;
  }

  ol:first-of-type {
    counter-reset: clause;
  }

  ol > li::before {
    position: absolute;
    margin-left: -3.5rem;
    counter-increment: clause;
    content: counters(clause, ".") ". ";
  }

  ul > li::before {
    position: absolute;
    margin-left: -2rem;
    content: "•";
  }

  ol ol ol ol > li::before {
    position: absolute;
    margin-left: -2rem;
    counter-increment: clause;
    content: counter(clause, lower-roman) ". ";
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  @media screen and (min-width: 561px) {
    ol li ol {
      margin-left: 3.5em;
    }

    h3,
    h4,
    h5,
    h6,
    li,
    p {
      font-size: 16px;
    }
  }
`);

export default Legals;
